export default "__VITE_ASSET__BSNLvmLi__"